"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
/**
 * 通过两点求一个直线表达式
 *
 * @param p1 点1
 * @param p2 点2
 */
function towPointLine(p1, p2) {
    /*
        A=Y2-Y1=p2[1]-p1[1]
        B=X1-X2=p1[0]-p2[0]
        C=X2*Y1-X1*Y2=p2[0]*p1[1]-p1[0]*p2[1]
     */
    return [p2[1] - p1[1], p1[0] - p2[0], p2[0] * p1[1] - p1[0] * p2[1]];
}
exports.towPointLine = towPointLine;
/**
 * 计算两个点之间的距离
 * @param p1 点1
 * @param p2 点2
 */
function towPointDis(p1, p2) {
    return Math.sqrt((p1[0] - p2[0]) * (p1[0] - p2[0]) + (p1[1] - p2[1]) * (p1[1] - p2[1]));
}
exports.towPointDis = towPointDis;
/**
 * 直线函数化
 * @param line 直线
 */
function linefn(line) {
    return function linef(p) {
        return line[0] * p[0] + line[1] * p[1] + line[2];
    };
}
exports.linefn = linefn;
/**
 * 判断点1与点2是否在直线的同侧 包含再线上的点
 * @param line 直线
 * @param p1 点1
 * @param p2 点2
 */
function isIpsilateral(line, p1, p2) {
    var lf = linefn(line);
    return lf(p1) * lf(p2) >= 0;
}
exports.isIpsilateral = isIpsilateral;
/**
 * 判断多个点是否在线的同一侧
 * @param line 线
 * @param ps 点集合
 */
function isIpsilaterals(line) {
    var e_1, _a;
    var ps = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        ps[_i - 1] = arguments[_i];
    }
    var lf = linefn(line);
    var p = ps[0];
    try {
        for (var ps_1 = __values(ps), ps_1_1 = ps_1.next(); !ps_1_1.done; ps_1_1 = ps_1.next()) {
            var t = ps_1_1.value;
            if (lf(t) !== 0) {
                p = t;
                break;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (ps_1_1 && !ps_1_1.done && (_a = ps_1.return)) _a.call(ps_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    for (var i = 0; i < ps.length; i++)
        if (lf(p) * lf(ps[i]) < 0) {
            return false;
        }
    return true;
}
exports.isIpsilaterals = isIpsilaterals;
/**
 * 判断一个点是否再三角形内或边缘
 * @param triangle 三角形
 * @param point 点
 */
function isInTriangle(triangle, point) {
    return [
        [0, 1, 2],
        [0, 2, 1],
        [2, 1, 0]
    ].map(function (i) { return isIpsilateral(towPointLine(triangle[i[0]], triangle[i[1]]), triangle[i[2]], point); }).every(utils_1.eqT);
}
exports.isInTriangle = isInTriangle;
/**
 * 判断一个点是否在凸多边形内或边缘
 * @param polygon 多边形
 * @param point 点
 */
function isInPolygon(polygon, point) {
    var p = polygon[0];
    for (var i = 1; i < polygon.length - 1; i++) {
        var a = polygon[i];
        var b = polygon[i + 1];
        if (isInTriangle([p, a, b], point)) {
            return true;
        }
    }
    return false;
}
exports.isInPolygon = isInPolygon;
/**
 * 判断一个多边形是否为凸多边形
 * @param polygon 多边形
 */
function isConvex(polygon) {
    if (polygon.length === 3) { // 三角形必然是凸的
        return true;
    }
    var disList = utils_1.range(polygon.length)
        .map(function (i) { return [i, (i + 1) % polygon.length]; })
        .map(function (is) { return towPointLine(polygon[is[0]], polygon[is[1]]); });
    return disList.every(function (line) { return isIpsilaterals.apply(void 0, __spread([line], polygon)); }); // 所有内角均为钝角的多边形为凸多边形
}
exports.isConvex = isConvex;
/**
 * 获取点集合的矩形坐标
 * @param points 点集合
 */
function getPointsRect(points) {
    var e_2, _a;
    if (points.length === 0) {
        return [0, 0, 0, 0];
    }
    var minx = points[0][0], miny = points[0][1], maxx = points[0][0], maxy = points[0][1];
    try {
        for (var points_1 = __values(points), points_1_1 = points_1.next(); !points_1_1.done; points_1_1 = points_1.next()) {
            var p = points_1_1.value;
            var _b = __read(p, 2), x = _b[0], y = _b[1];
            if (x > maxx) {
                maxx = x;
            }
            if (x < minx) {
                minx = x;
            }
            if (y > maxy) {
                maxy = y;
            }
            if (y < miny) {
                miny = y;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (points_1_1 && !points_1_1.done && (_a = points_1.return)) _a.call(points_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return [minx, miny, Math.abs(minx - maxx), Math.abs(miny - maxy)];
}
exports.getPointsRect = getPointsRect;
/**
 * 判断点是否在矩形区域内
 * @param rect 矩形区域
 * @param p 点
 */
function isInRect(rect, p) {
    var _a = __read(rect, 4), x = _a[0], y = _a[1], w = _a[2], h = _a[3];
    var _b = __read(p, 2), x0 = _b[0], y0 = _b[1];
    return x0 >= x && x0 <= x + w && y0 >= y && y0 <= y + h;
}
exports.isInRect = isInRect;
/**
 * 返回点所在的第一个矩形区域
 * @param rects 多个矩形区域
 * @param p 点
 */
function isInRects(rects, p) {
    return rects.findIndex(function (item) { return isInRect(item, p); });
}
exports.isInRects = isInRects;
/**
 * 复制一个路径
 * @param src 源
 */
function copyPath(src) {
    var path = [];
    src.forEach(function (item) { return path.push([item[0], item[1]]); });
    return path;
}
exports.copyPath = copyPath;
/**
 * 创建变换矩阵
 */
function createTransformMatrix() {
    return [
        1, 0, 0,
        0, 1, 0,
        0, 0, 1,
    ];
}
exports.createTransformMatrix = createTransformMatrix;
/**
 * 变换一个点
 * @param m 变换矩阵
 * @param p 需要变换的点
 */
function transform(m, p) {
    var _a = __read(p, 2), x = _a[0], y = _a[1];
    return [
        m[0] * x + m[1] * y + m[2],
        m[3] * x + m[4] * y + m[5],
    ];
}
exports.transform = transform;
/**
 * 变换一个路径
 * @param m 变换矩阵
 * @param path 需要变换的路径
 */
function transformPath(m, path) {
    return path.map(function (p) { return transform(m, p); });
}
exports.transformPath = transformPath;
/**
 * 返回平移后新的变换矩阵
 * @param m 变换矩阵
 * @param x x增量
 * @param y y增量
 * @param z z增量
 */
function translate(m, x, y, z) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    if (z === void 0) { z = 0; }
    var nm = createTransformMatrix();
    nm[2] += x;
    nm[5] += y;
    nm[8] += z;
    return multiplyTransformMatrix(m, nm);
}
exports.translate = translate;
/**
 * 返回伸缩后新的变换矩阵
 * @param m 变换矩阵
 * @param x x增量
 * @param y y增量
 * @param z z增量
 */
function scale(m, x, y, z) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    if (z === void 0) { z = 0; }
    var nm = createTransformMatrix();
    nm[0] += x;
    nm[4] += y;
    nm[8] += z;
    return multiplyTransformMatrix(m, nm);
}
exports.scale = scale;
/**
 * 变换矩阵相乘
 * @param a 矩阵a
 * @param b 矩阵b
 */
function multiplyTransformMatrix(a, b) {
    var _a = __read(a, 9), a11 = _a[0], a12 = _a[1], a13 = _a[2], a21 = _a[3], a22 = _a[4], a23 = _a[5], a31 = _a[6], a32 = _a[7], a33 = _a[8];
    var _b = __read(b, 9), b11 = _b[0], b12 = _b[1], b13 = _b[2], b21 = _b[3], b22 = _b[4], b23 = _b[5], b31 = _b[6], b32 = _b[7], b33 = _b[8];
    return [
        a11 * b11 + a12 * b21 + a13 * b31, a11 * b12 + a12 * b22 + a13 * b32, a11 * b13 + a12 * b23 + a13 * b33,
        a21 * b11 + a22 * b21 + a23 * b31, a21 * b12 + a22 * b22 + a23 * b32, a21 * b13 + a22 * b23 + a23 * b33,
        a31 * b11 + a32 * b21 + a33 * b31, a31 * b12 + a32 * b22 + a33 * b32, a31 * b13 + a32 * b23 + a33 * b33,
    ];
}
exports.multiplyTransformMatrix = multiplyTransformMatrix;
/**
 * 判断两点是否相等
 * @param p0 点1
 * @param p1 点2
 */
function pointEq(p0, p1) {
    return p0[0] === p1[0] && p0[1] === p1[1];
}
exports.pointEq = pointEq;
/**
 * 判断两路径是否相等
 * @param path0 路径1
 * @param path1 路径2
 */
function pathEq(path0, path1) {
    if (path0.length !== path1.length) {
        return false;
    }
    for (var i = 0; i < path0.length; i++) {
        var _a = __read([path0[i], path1[i]], 2), p0 = _a[0], p1 = _a[1];
        if (!pointEq(p0, p1)) {
            return false;
        }
    }
    return true;
}
exports.pathEq = pathEq;
/**
 * 返回两个路径中不同点的下标,若路径长度不一致则抛出错误
 * @param path0 路径1
 * @param path1 路径2
 */
function twoPathNotEqPoints(path0, path1) {
    if (path0.length !== path1.length) {
        throw new Error('path length is not equal');
    }
    var result = [];
    for (var i = 0; i < path0.length; i++) {
        var _a = __read([path0[i], path1[i]], 2), p0 = _a[0], p1 = _a[1];
        if (!pointEq(p0, p1)) {
            result.push(i);
        }
    }
    return result;
}
exports.twoPathNotEqPoints = twoPathNotEqPoints;
//# sourceMappingURL=planimetry.js.map